export const ENV = {
  BASE_API_URL: String(window._env_.REACT_APP_BASE_API_URL),
  LOGIN_URL: String(window._env_.REACT_APP_LOGIN_URL),
  LOGOUT_URL: String(window._env_.REACT_APP_LOGOUT_URL),
  REACT_APP_TAG_GOOGLE: String(window._env_.REACT_APP_TAG_GOOGLE),
  REACT_APP_BACKGROUND_IMAGES: String(window._env_.REACT_APP_BACKGROUND_IMAGES),
};
